import { siteInfo } from "@/mocks/site";

export default function TopBar() {
  return (
    <div className="hidden md:block w-full bg-foreground-950 text-background-50/80 text-xs">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-9 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="inline-flex w-1.5 h-1.5 rounded-full bg-accent-500" />
          <span className="tracking-wide">HANKUK RUBBER TECH · 산업용 고무제품 전문 제조</span>
        </div>
        <div className="flex items-center gap-6">
          <a
            href={siteInfo.telLink}
            className="inline-flex items-center gap-2 hover:text-accent-300 transition-colors cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-[12px]" />
            </span>
            TEL · {siteInfo.tel}
          </a>
          <a
            href={siteInfo.emailLink}
            className="inline-flex items-center gap-2 hover:text-accent-300 transition-colors cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-fill text-[12px]" />
            </span>
            {siteInfo.email}
          </a>
        </div>
      </div>
    </div>
  );
}